module.exports = __webpack_public_path__ + "img/whiteuparrow.7813e657.svg";